import React from 'react'
import { ConfigProvider, Skeleton, Flex } from 'antd';


const ViewBrandsSkeleton: React.FC = () => {
    return (
        <ConfigProvider
            theme={{
                components: {
                    Skeleton: {
                        gradientFromColor: "#404040",
                        gradientToColor: "#606060"
                    },
                },
            }}>




            <div className="bg-[#1E1E1E] flex h-[68px] items-center rounded-lg px-3 py-4">
                <div className="flex w-full flex-col">
                    <Flex className="w-full" gap={12} align="center">
                        <div className="shrink-0">
                            <Skeleton.Avatar
                                active
                                style={{ width: "54px", height: "54px" }}
                                shape="circle"
                            />
                        </div>

                        <div className="mt-1 flex min-w-0 flex-1 flex-col gap-2">
                            <Skeleton.Input
                                size="small"
                                style={{ width: "100%", maxWidth: "190px", height: "10px" }}
                                active
                            />
                            <Skeleton.Input
                                size="small"
                                style={{ width: "60%", maxWidth: "100px", height: "9px" }}
                                active
                            />
                        </div>
                    </Flex>
                </div>
            </div>
        </ConfigProvider>
    )
}

export default ViewBrandsSkeleton

